<body class="app">
  <header class="app-header navbar"
  style="width: 100%; height: 30%;"
  >
    <!-- Header content here -->
  </header>



<div class="app-body" >
    <main class="main d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mx-auto">
            <div class="card-group">
              <div class="card p-4">
                <div class="card-body">
                  <form [formGroup]="loginForm" (ngSubmit)="onSubmitLogin()">
                      <h1>Iniciar Sesion</h1>
                      <p class="text-muted">Ingresa tu cuenta</p>
                      <div class="input-group mb-3">
                          <div class="input-group-prepend">
                              <span class="input-group-text"><i class="icon-user"></i></span>
                          </div>
                          <input type="text" class="form-control" placeholder="Usuario"
                              autocomplete="username" formControlName="usuario" required>
                      </div>
                      <div class="input-group mb-4">
                          <div class="input-group-prepend">
                              <span class="input-group-text"><i class="icon-lock"></i></span>
                          </div>
                          <input type="password" class="form-control" placeholder="Password"
                              autocomplete="current-password" formControlName="password" required>
                      </div>
                      <div class="row">
                          <div class="col-6">
                              <button type="submit" class="btn btn-primary px-4"><span *ngIf="!load" class="spinner-border spinner-border-sm mr-1"></span>Ingresar</button>
                          </div>
                          <div class="col-6 text-right">
                              <a [routerLink]="['/reset-password']">¿Olvidaste tu
                                  Contraseña?</a>
                          </div>
                      </div>
                  </form>
                </div>
              </div>
              <div class="card text-white bg-primary  d-md-down-none" style="width:44%">
                <!-- <div class="card-body text-center"> -->
                  <img src="assets/img/home/logo.jpg" alt="Logo">
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  

  <footer class="app-footer">
    <!-- Footer content here -->
  </footer>
</body>